<h2>{{ t('bannerCarousel') }}</h2>

<div style="max-width:560px; display:flex; flex-direction:column; gap:10px; margin-bottom:10px">

  <label>
    {{ languageService.language() === 'bn' ? 'ব্যানারটি কোথায় দেখাবে' : 'Where to show this banner' }}
    <select [(ngModel)]="selectedSlot" style="display:block; width:100%; padding:8px; margin-top:4px">
      <option *ngFor="let s of slots" [value]="s.key">
        {{ languageService.language() === 'bn' ? s.labelBn : s.labelEn }}
      </option>
    </select>
  </label>

  <label>
    {{ languageService.language() === 'bn' ? 'ক্লিক করলে যে লিংকে যাবে (ঐচ্ছিক)' : 'Link when clicked (optional)' }}
    <input
      type="text"
      [(ngModel)]="linkUrl"
      placeholder="/offers  অথবা  https://..."
      style="display:block; width:100%; padding:8px; margin-top:4px">
  </label>

  <input
    type="file"
    accept="image/*"
    (change)="select($event)">

  <small style="color:#666">
    {{ languageService.language() === 'bn'
        ? 'সেকশনের পরের বিজ্ঞাপনের জন্য চওড়া ব্যানার ভালো (যেমন ১৪০০×২০০ px)। একই জায়গায় একাধিক দিলে ঘুরে ঘুরে দেখাবে।'
        : 'For in-page ads use a wide banner (e.g. 1400×200 px). Multiple banners in one place rotate.' }}
  </small>

  <button (click)="save()" [disabled]="!file">
    {{ t('uploadBanner') }}
  </button>

</div>

<hr>

<ng-container *ngFor="let s of slots">

  <ng-container *ngIf="bannersFor(s.key).length">

    <h3 style="margin:18px 0 6px">{{ slotLabel(s.key) }}</h3>

    <div
      *ngFor="let b of bannersFor(s.key)"
      style="margin:12px 20px">

      <img
        [src]="b.imageUrl"
        width="350">

      <div *ngIf="b.linkUrl" style="font-size:12px; color:#666; margin-top:4px">
        → {{ b.linkUrl }}
      </div>

      <br>

      <button
        (click)="delete(b.id)">

        {{ t('delete') }}

      </button>

    </div>

  </ng-container>

</ng-container>
